import { render, staticRenderFns } from "./BuildItem.vue?vue&type=template&id=5a321dfa"
import script from "./BuildItem.vue?vue&type=script&lang=js"
export * from "./BuildItem.vue?vue&type=script&lang=js"
import style0 from "./BuildItem.vue?vue&type=style&index=0&id=5a321dfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports